/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type { ListPage } from './types';
import { ContractMenuType, ContractType } from '../constants';

const yApiObj = {
  // yapi: 1263
};

enum Api {
  listPage = '/front-end/ht/contract/list', // 合同列表
  getContractDetail = '/front-end/ht/contract/info', // 获取合同详情
  downloadContract = '/front-end/ht/contract/download',
  getParticipatantList = '/back-end/ht/type/participants', // 获取可选的参与方列表
  getContractTypeApi = '/front-end/ht/contract/contractType',
  applyForQuiesceApi = '/front-end/ht/contract/applyForQuiesce', // 合同-申请静默签约
  queryQuiesceApi = '/front-end/ht/contract/queryQuiesce',
  getEnterpriseList = '/back-end/ht/type/participants/entpList', // 企业关联公司-获取企业列表
  getContractUserInfoApi = '/front-end/ht/contract/contractList/userInfo',
  getParticipatantOpt = '/front-end/ht/contract/type/participants', // 列表-参与方选项

  contractAddOrUpdateApi = '/back-end/ht/contract/contractAddOrUpdate', // 编辑合同模板
  platformDicList = '/back-end/ht/contract/platformDicList', // 获取平台标识
  parkList = '/back-end/ht/contract/parkList', // 查询园区-根据代办供应商id

  uploadMarketServiceContract = '/front-end/ht/contract/contractAddOrUpdate', // 服务商自助上传线下市场服务合同
  getBoundIndustryList = '/front-end/ht/contract/type/participants/entpList', // 当前服务商预绑定的工业下拉
  // 终端人员签约策略 + 自动签署（服务商全局）
  getTerminalSignStrategy = '/front-end/ht/contract/sunflowerContractStatus',
  saveTerminalSignStrategy = '/front-end/ht/contract/sunflowerContractSwitch',
  // 合同模版（终端人员 / 内部雇员）
  listTerminalTemplate = '/front-end/ht/template/contractTemplateList',
  getTerminalTemplate = '/front-end/ht/template/contractTemplate/info',
  saveTerminalTemplate = '/front-end/ht/template/contractTemplate/addOrUpdate',
  delOrEnabledTemplate = '/front-end/ht/template/contractTemplate/delOrEnabled',
  // 市场服务合同签署要求配置（工业·向日葵服务助手）
  contractReqQuery = '/front-end/ht/contract/sunflowerMarketContractQuery', // 查询（含开关/计数/服务商列表）
  contractReqSwitch = '/front-end/ht/contract/sunflowerMarketContractSwitch' // 操作（全局开关/单家/批量）
}

/** 编辑合同模板 */
export const addOrUpdateContract = async params => {
  return await http.request(
    {
      url: Api.contractAddOrUpdateApi,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );
};

/**
 * 获取平台标识
 */
export const platformDicList = async params => {
  return await http.request(
    {
      url: Api.platformDicList,
      method: 'POST',
      params: { ...params }
    },
    {
      ...yApiObj
    }
  );
};

/**
 * 查询园区-根据代办供应商
 */
export const parkList = async params => {
  return await http.request(
    {
      url: Api.parkList,
      method: 'POST',
      params: { ...params }
    },
    {
      ...yApiObj
    }
  );
};
/**
 * 合同列表
 */
export const listPage: ListPage = params =>
  http.request(
    {
      url: Api.listPage,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );

/** 获取合同详情 */
export const getContractDetail = async params => {
  return await http.request(
    {
      url: Api.getContractDetail,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );
};
/**
 * 合同下载
 */
export const downloadContract = async params =>
  http.download({
    url: Api.downloadContract,
    method: 'POST',
    params
  });

/**
 * 获取可选的参与方列表
 */
export const getPartOptList = async params => {
  const { data } = await http.request(
    {
      url: Api.getParticipatantList,
      method: 'POST',
      params: { ...params, source: 2, port: 1 }
    },
    {
      // yapi: 1271
    }
  );
  return data;
};

/** 合同-获取当前登录者的合同类型 */
export const getContractType = async params => {
  const { data } = await http.request(
    {
      url: Api.getContractTypeApi,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return data;
};

/** 合同-申请静默签约 */
export const applyForQuiesce = async params => {
  const { data } = await http.request(
    {
      url: Api.applyForQuiesceApi,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return data;
};

/** 合同-获取登录的企业，是否开启静默签约 */
export const queryQuiesce = async params => {
  const { data } = await http.request(
    {
      url: Api.queryQuiesceApi,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return data;
};
/**
 * 获取签署主体对应的企业列表
 */
export const getEnterpriseList = async (
  params: {
    index; // 0-甲方， 1-乙方
    participantValue?: string; // 企业类型 1-工业 2-服务商
    entpName?: string; // 企业名称
    type: number; // 类型
    contractType: number; // 合同类型
    entpId: number;
  },
  entpInfo?
) => {
  const res = await http.request(
    {
      url: Api.getEnterpriseList,
      method: 'POST',
      params: {
        ...params,
        source: params.type === ContractMenuType.TEMPLATE ? 1 : 2,
        contractType: params.contractType,
        pageNum: 1,
        pageSize: 80
      }
    },
    {
      ...yApiObj
    }
  );

  // 乙方 或者
  // 项目服务合同-甲方有，乙方没有
  let hasTemplate = false;
  if (+params.index !== 0) {
    hasTemplate = true;
  }
  if (params.contractType === ContractType.PROJECT) {
    hasTemplate = +params.index === 0 ? true : false;
  }
  let selectedEntp = [];
  const list = [
    ...(params.type === ContractMenuType.TEMPLATE && hasTemplate
      ? [
          {
            id: 'all',
            name: '根据模板选择'
          }
        ]
      : []),
    ...res.data?.list?.map(item => ({
      ...item,
      name: `${item.name}${item.phone ? `(${item.phone?.slice(-4)})` : ''}`
    }))
  ];
  if (entpInfo?.id) {
    if (!list.some(item => item.id === entpInfo.id)) {
      selectedEntp = [entpInfo];
    }
  }
  return {
    ...res,
    data: {
      ...res.data,
      list: [...list, ...selectedEntp]
    }
  };
};

/** 合同管理-列表-企业信息/个人信息 */
export const getContractUserInfo = async params => {
  return await http.request(
    {
      url: Api.getContractUserInfoApi,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );
};

/** 合同管理-列表-签署方下拉选项 */
export const getParticipatantOpt = async params => {
  return await http.request(
    {
      url: Api.getParticipatantOpt,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );
};

/* ---------------- 向日葵服务助手·市场服务合同自助上传 ---------------- */

/**
 * 服务商自助上传线下市场服务合同
 */
export const uploadMarketServiceContract = async (params: {
  firstPartyId: number; // 签署方（关联工业）
  contractName: string; // 合同名称
  validityStart: string; // 签署日期起
  validityEnd: string; // 签署日期止
  remarks: string; // 备注
  contractRenderUrl: string; //上传文件
  urlFileName: string; //上传文件
  /** 合同类型，市场服务合同固定为 3 */
  type: number;
}) =>
  http.request(
    {
      url: Api.uploadMarketServiceContract,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );

/**
 * 当前服务商预绑定的工业下拉
 * 响应字段约定：{ list: [{ id, companyName }] }
 */
export const getBoundIndustryList = async (params: {
  type: number; // 你写死 2-合同管理     类型 1 合同模板管理   2合同管理
  entpName: string;
  participantValue: number; // 查询工业-1  查询服务商-2
  contractType: number; // 合同类型 3-市场服务
  taxPattern: number; // 交易结构 不用传
  source: number; // 写死2  来源 ： 来源  1-模板过来的， 2-合同过来的
  pageNum: number; //必传
  pageSize: number; // 必传
}): Promise<{
  data: { list: Array<{ id: number; companyName: string }> };
}> =>
  http.request(
    {
      url: Api.getBoundIndustryList,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );

/* -------------- 终端人员签约策略 + 自动签署 -------------- */

export interface TerminalSignStrategy {
  signTerminalContract: 0 | 1 | null; // 0-关闭(默认null 也是关闭) 1-开启
  isAutoSign: number; // 是否静默签署 0 自动签署(静默) 已开启  1 手动签署(非静默) 关闭
  marketServicePersonTemplate: {
    id: number;
    contractTemplateName: string; //取模板名字
  };
}

export const getTerminalSignStrategy = async (): Promise<{
  data: TerminalSignStrategy;
}> =>
  http.request(
    { url: Api.getTerminalSignStrategy, method: 'POST' },
    { ...yApiObj }
  );

export const saveTerminalSignStrategy = async (
  params: Partial<TerminalSignStrategy>
) =>
  http.request(
    { url: Api.saveTerminalSignStrategy, method: 'POST', params },
    { ...yApiObj }
  );

/* -------------- 终端人员 / 内部雇员合同模版管理 -------------- */
import { TerminalTemplateStatus, DelOrEnabledType } from '../constants';
import type { TerminalTemplateRow } from './types';

export const listTerminalTemplate = async (params: {
  pageNum: number;
  pageSize: number;
  name?: string;
  status?: TerminalTemplateStatus;
}): Promise<{
  data: { list: TerminalTemplateRow[]; total: number };
}> =>
  http.request(
    { url: Api.listTerminalTemplate, method: 'POST', params },
    { ...yApiObj }
  );

export const getTerminalTemplate = async (params: {
  id: number;
}): Promise<{ data: TerminalTemplateRow }> =>
  http.request(
    { url: Api.getTerminalTemplate, method: 'POST', params },
    { ...yApiObj }
  );

export const saveTerminalTemplate = async (
  params: Omit<TerminalTemplateRow, 'id' | 'createAt'> & {
    id?: number;
    /** 1 校验是否重复，0 确认保存 */
    check?: number;
  }
): Promise<{
  /** 7778 表示模版重复需二次确认；否则返回停用份数等信息 */
  data: number | { disabledCount?: number };
}> =>
  http.request(
    { url: Api.saveTerminalTemplate, method: 'POST', params },
    { ...yApiObj }
  );

export const delOrEnabledTemplate = async (params: {
  id: number;
  type: DelOrEnabledType;
  enabled?: TerminalTemplateStatus;
  check?: number;
}): Promise<{ data: number }> =>
  http.request(
    { url: Api.delOrEnabledTemplate, method: 'POST', params },
    { ...yApiObj }
  );

/* ---------------- 市场服务合同签署要求配置（工业·向日葵服务助手） ---------------- */

export interface ContractReqSpItem {
  finalDeptId: number;
  entpName: string;
  entpCertNo: string; // 统一社会信用代码
  isUploadContract: number; // 0-否 1-是
}

/** 查询市场服务合同签署要求 */
export const queryContractReq = async (): Promise<{
  data: {
    signMarketContract: number;
    totalServiceProviderCount: number;
    requireUploadCount: number;
    serviceProviderList: ContractReqSpItem[];
  };
}> =>
  http.request(
    { url: Api.contractReqQuery, method: 'POST' },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    }
  );

/** 操作开关：全局默认策略 / 单家 / 批量 */
export const switchContractReq = async (params: {
  signMarketContract?: number | null; // 全局开关，null 不修改
  isUploadContract?: number | null; // 上传要求，null 不修改
  aspId?: number; // 传入=单家操作，不传=全部操作
}) =>
  http.request(
    { url: Api.contractReqSwitch, method: 'POST', params },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    }
  );
